import { render, staticRenderFns } from "./DomainListItem.vue?vue&type=template&id=2d8c1212&"
import script from "./DomainListItem.vue?vue&type=script&lang=js&"
export * from "./DomainListItem.vue?vue&type=script&lang=js&"
import style0 from "./DomainListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports